import { match } from "ts-pattern";

import {
  type AppUserActionPart,
  type CreateAction,
  type DeactivateAction,
  type ReactivateAction,
  suggestedAction,
} from "../types/action";
import { RULE_MATCHING } from "../types/ruleMatch";

// 各RuleMatchingに対して具体的な戻り値の型を定義
type NoUserAction = CreateAction | undefined;
type ActiveUserAction = DeactivateAction | ReactivateAction | undefined;

// オーバーロードシグネチャを定義
function determineActionByRule(
  action: AppUserActionPart | undefined,
  ruleMatching: typeof RULE_MATCHING.NO_USER,
): NoUserAction;
function determineActionByRule(
  action: AppUserActionPart | undefined,
  ruleMatching:
    | typeof RULE_MATCHING.MATCHED
    | typeof RULE_MATCHING.VIOLATED
    | typeof RULE_MATCHING.NO_WORKER,
): ActiveUserAction;

/**
 * ルールのマッチング状況とアクション情報に基づいて、実行すべきアクションを決定する実装関数
 * @param action - 提案されたアクションの部分情報
 * @param ruleMatching - ルールのマッチング状況
 * @returns 決定されたアクション（作成、有効化、無効化）またはundefined
 */
function determineActionByRule(
  action: AppUserActionPart | undefined,
  ruleMatching: keyof typeof RULE_MATCHING,
): NoUserAction | ActiveUserAction {
  if (!action) {
    return undefined;
  }

  return match<[keyof typeof RULE_MATCHING, string]>([
    ruleMatching,
    action.type,
  ])
    .with([RULE_MATCHING.NO_USER, suggestedAction.CREATE], () => ({
      type: suggestedAction.CREATE,
      disabled: action.disabled,
    }))
    .with([RULE_MATCHING.MATCHED, suggestedAction.DEACTIVATE], () => ({
      type: suggestedAction.DEACTIVATE,
      disabled: action.disabled,
      describe: action.describe ?? "",
    }))
    .with([RULE_MATCHING.VIOLATED, suggestedAction.DEACTIVATE], () => ({
      type: suggestedAction.DEACTIVATE,
      disabled: action.disabled,
      describe: action.describe ?? "",
    }))
    .with([RULE_MATCHING.NO_WORKER, suggestedAction.DEACTIVATE], () => ({
      type: suggestedAction.DEACTIVATE,
      disabled: action.disabled,
      describe: action.describe ?? "",
    }))
    .with([RULE_MATCHING.MATCHED, suggestedAction.REACTIVATE], () => ({
      type: suggestedAction.REACTIVATE,
      disabled: action.disabled,
    }))
    .with([RULE_MATCHING.VIOLATED, suggestedAction.REACTIVATE], () => ({
      type: suggestedAction.REACTIVATE,
      disabled: action.disabled,
    }))
    .with([RULE_MATCHING.NO_WORKER, suggestedAction.REACTIVATE], () => ({
      type: suggestedAction.REACTIVATE,
      disabled: action.disabled,
    }))
    .otherwise(() => undefined);
}

export { determineActionByRule };
